import styled from 'styled-components';

const Image = styled.div`
  margin-bottom: 1rem;
`;

export default Image;
